import React from "react"

// set the defaults
const QuotesContext = React.createContext({
  activeQuote: 0,
  numOfQuotes: 20,
  showQuote: false,
})

export default QuotesContext
